import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, Slot } from "@builder.io/qwik";
const HTabList = component$((props) => {
  return /* @__PURE__ */ jsx("div", {
    role: "tablist",
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HTabList
};
